module.exports = __webpack_public_path__ + "img/product99p.7330b049.png";